// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3GYow","notes":"Notes_notes__IyqM3","note":"Notes_note__3um3b","markdown":"Notes_markdown__Pl6RU"};